import React, { useState } from 'react';
import MygaSection from './BookOfBusiness/MygaSection';
import FiaSection from './BookOfBusiness/FiaSection';
import SpiaSection from './BookOfBusiness/SpiaSection';
import SpdaSection from './BookOfBusiness/SpdaSection';
import MedSupSection from './BookOfBusiness/MedSupSection';
import FilterIcon from "../../SVG/Filter";

const CurrentBusinessNav = ({ types, selectedType, onSelectType }) => {
    return (
        <div className="agent-business-subnav">
            {types.map((type) => (
                <button
                    key={type}
                    onClick={() => onSelectType(type)}
                    className={`agent-business-selector ${selectedType === type ? 'active' : ''}`}
                >
                    {type}
                </button>
            ))}
        </div>
    );
};

const CurrentBusinessSection = ({ model }) => {
    // ENV Variables
    const envTypes = import.meta.env.VITE_BOB_TYPES || '';

    const types = envTypes
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);

    const finalTypes = types.length ? types : ['MYGA', 'SPIA', 'FIA'];

    // State
    const [selectedType, setSelectedType] = useState(finalTypes[0]);
    const [agtCode, setAgtCode] = useState("All");
    const [polNo, setPolNo] = useState("");
    const [ownerName, setOwnerName] = useState("");
    const [currentRows, setCurrentRows] = useState([]);

    const downLines = model.downlines || [];

    const handleExport = () => {
        if (!currentRows || currentRows.length === 0) {
            alert("There are no records to export.");
            return;
        }

        const headers = Object.keys(currentRows[0]);

        const escapeCsvValue = (value) => {
            if (value === null || value === undefined) {
                return "";
            }

            const stringValue = String(value);

            return `"${stringValue.replace(/"/g, '""')}"`;
        };

        const csvRows = [
            headers.join(","),
            ...currentRows.map(row =>
                headers
                    .map(header => escapeCsvValue(row[header]))
                    .join(",")
            )
        ];

        const csvContent = csvRows.join("\r\n");

        const blob = new Blob(
            [csvContent],
            { type: "text/csv;charset=utf-8;" }
        );

        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");

        link.href = url;
        link.download = `${selectedType}_BookOfBusiness.csv`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
    };

    return (
        <div
            className="container container-section"
            id="current-business-container"
        >
            {/* Filter Box */}
            <div className="filter-box">
                <FilterIcon />

                <div className="filter-item">
                    <label
                        htmlFor="agtCode"
                        className="filterLabel"
                    >
                        Downline
                    </label>

                    <select
                        id="agtCode"
                        className="filterInput"
                        value={agtCode}
                        onChange={(e) => setAgtCode(e.target.value)}
                    >
                        <option value="All">
                            All
                        </option>

                        <option value={model.agtCode}>
                            {model.agtCode} - {model.agentInfo?.displayName || "You"}
                        </option>

                        {downLines.map((dl) => (
                            <option
                                key={dl.agentCode}
                                value={dl.agentCode}
                            >
                                {dl.agentCode} - {dl.displayName}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="filter-item">
                    <label
                        htmlFor="polNo"
                        className="filterLabel"
                    >
                        Policy
                    </label>

                    <input
                        id="polNo"
                        type="text"
                        className="filterInput"
                        value={polNo}
                        onChange={(e) => setPolNo(e.target.value)}
                    />
                </div>

                <div className="filter-item">
                    <label
                        htmlFor="ownerName"
                        className="filterLabel"
                    >
                        Owner
                    </label>

                    <input
                        id="ownerName"
                        type="text"
                        className="filterInput"
                        value={ownerName}
                        onChange={(e) => setOwnerName(e.target.value)}
                    />
                </div>

                <div className="filterButton">
                    <button
                        type="button"
                        className="filterButton"
                        onClick={handleExport}
                        disabled={currentRows.length === 0}
                    >
                        Export
                    </button>
                </div>
            </div>

            <div className="agent-business-container">
                <CurrentBusinessNav
                    types={finalTypes}
                    selectedType={selectedType}
                    onSelectType={setSelectedType}
                />

                {selectedType === 'MYGA' && (
                    <MygaSection
                        model={model}
                        agtCode={agtCode}
                        polNo={polNo}
                        ownerName={ownerName}
                        onFilteredRowsChange={setCurrentRows}
                    />
                )}

                {selectedType === 'FIA' && (
                    <FiaSection
                        model={model}
                        agtCode={agtCode}
                        polNo={polNo}
                        ownerName={ownerName}
                        onFilteredRowsChange={setCurrentRows}
                    />
                )}

                {selectedType === 'SPIA' && (
                    <SpiaSection
                        model={model}
                        agtCode={agtCode}
                        polNo={polNo}
                        ownerName={ownerName}
                        onFilteredRowsChange={setCurrentRows}
                    />
                )}

                {selectedType === 'SPDA' && (
                    <SpdaSection
                        model={model}
                        agtCode={agtCode}
                        polNo={polNo}
                        ownerName={ownerName}
                        onFilteredRowsChange={setCurrentRows}
                    />
                )}

                {selectedType === 'MS' && (
                    <MedSupSection
                        model={model}
                        agtCode={agtCode}
                        polNo={polNo}
                        ownerName={ownerName}
                        onFilteredRowsChange={setCurrentRows}
                    />
                )}
            </div>
        </div>
    );
};

export default CurrentBusinessSection;